import { render, staticRenderFns } from "./AboutValues.vue?vue&type=template&id=49a083a6&scoped=true"
import script from "./AboutValues.vue?vue&type=script&lang=js"
export * from "./AboutValues.vue?vue&type=script&lang=js"
import style0 from "./AboutValues.vue?vue&type=style&index=0&id=49a083a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a083a6",
  null
  
)

export default component.exports